import {Button} from "@/components/ui/Button";
import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {Dialog} from "@/components/ui/dialog";
import {DialogContent} from "@/components/ui/dialog";
import {Icon} from "@/components/ui/icon";
import {TriangleAlert} from "lucide-react";

export const PageLeaveModal = ({
  onLeave,
  onCancel,
  showModal,
  setShowModal,
}: {
  onLeave: () => void;
  onCancel: () => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}) => {
  const handleCancel = () => {
    setShowModal(false);
    onCancel && onCancel();
  };

  const handleLeave = () => {
    onLeave && onLeave();
    setShowModal(false);
  };

  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent className="w-110 min-w-110 overflow-hidden">
        <DialogHeader className="sr-only">
          <DialogTitle>You have Unsaved Changes!</DialogTitle>
        </DialogHeader>
        <DialogDescription className="sr-only">
          If you close this page, all changes will be lost. Are you sure you
          want to leave?
        </DialogDescription>

        <div className="bg-white p-6 rounded-lg w-110 flex flex-col items-center gap-5">
          <Icon className="bg-red-50 border-red-100 rounded-lg" size="lg">
            <TriangleAlert size={28} className="text-red-500" />
          </Icon>
          <div className="flex flex-col items-center gap-2 text-center">
            <h2 className="text-lg font-bold">You have Unsaved Changes!</h2>
            <p className="text-sm text-label">
              If you close this page, all changes will be lost. Are you sure you
              want to leave?
            </p>
          </div>
          <div className="flex justify-between w-full gap-3">
            <Button onClick={handleCancel} variant="outline" className="w-1/2">
              No, Return to Flow
            </Button>
            <Button
              onClick={handleLeave}
              variant="outline-destructive"
              className="w-1/2"
            >
              Yes, Leave
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
